<template>
  <div id="fileList">
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="6" lg="6" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" locale="vi" :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
            :popover="{ visibility: 'click' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input :value="inputValue.start + ' - ' + inputValue.end" v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300" readonly />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2">
        <BaseSelect :options="typeFileSelect.options" :data="typeFileSelect.data" ref="typeFileSelect"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="6" lg="6" xl="2">
        <BaseInput :options="titleInput.options" :data="titleInput.data" :listener="titleInput.listener" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
              v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
              v-c-tooltip.hover="'Thêm mới'" class="btn-action-primary"
              @click="$router.push('/media-management/upload.html')">
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow class="row-2">

    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-else></td>
          </template>
          <template #duration="{ item }">
            <td>
              {{ item.duration }}
              <span v-if="item.size">
                {{ '/ ' + $helper.formatFileSize(item.size) }}
              </span>
            </td>
          </template>
          <template #description="{ item }">
            <td>
              <span :key="item.description" class="description"
                v-c-tooltip.hover="{ content: item.description, html: false }">{{
                  item.description
                }}</span>
            </td>
          </template>
          <template #fileTypeName="{ item }">
            <td>
              <span :key="item.fileTypeName" class="description"
                v-c-tooltip.hover="{ content: item.fileTypeName, html: false, placement: 'right'}">{{
                  item.fileTypeName
                }}</span>
            </td>
          </template>
          <template #status="{ item }">
            <td>
              <span v-if="item.status == 1" class="dot-custom dot-warning">Đang xử lý</span>
              <span v-else-if="item.status == 2" class="dot-custom  dot-success">Đã xử lý</span>
              <span v-else-if="item.status == 3" class="dot-custom  dot-danger">Xử lý lỗi</span>
            </td>
          </template>
          <template #locationName="{ item }">
            <td>
              <span class="badge badge-light" style="white-space: unset; line-height: 15px;">{{ item.locationName }}</span>
            </td>
          </template>
          <template #type="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.type === 0">Biên tập</span>
              <span class="badge badge-light" v-else-if="item.type === 1">Chuyển đổi văn bản</span>
              <span class="badge badge-light" v-else-if="item.type === 2">Ghi âm tệp tin</span>
              <span class="badge badge-light" v-else-if="item.type === 3">Ghép tệp tin</span>
              <template v-if="item.level">
                /
                <span class="badge badge-danger" v-if="item.level === 1">Khẩn cấp</span>
                <span class="badge badge-warning" v-else-if="item.level === 2">Ưu tiên</span>
                <span class="badge badge-info" v-else-if="item.level === 3">Thông thường</span>
              </template>
            </td>
          </template>
          <template #url="{ item }">
            <td v-if="item.url != null">
              <span class="view-file" @click="viewFile(item.title, item.url)">Ấn vào để xem</span>
            </td>
            <td v-else></td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Tải xuống'" square size="sm"
                  @click="downloadFile(item)"><i class="fa fa-download"></i>
                </CButton>
                <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="danger" variant="outline" square size="sm"
                  v-c-tooltip.hover="'Xóa'" @click="setupSelectOneAction('delete_one', item.id, item.title)">
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>

    <BaseFormPreview v-if="previewModel.isShowModal" :title="previewModel.title" :url="previewModel.url"
      @close-modal="previewModel.isShowModal = false"></BaseFormPreview>

  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";
import { DatePicker } from "v-calendar";
import VideoPlayer from "@/views/base/VideoPlayer";
import BaseFormPreview from "@/views/base/BaseFormPreview";

export default {
  name: "FileManagementList",
  components: {
    BaseFormPreview,
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    BaseModal,
    VideoPlayer,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/file-management/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "bản tin",
          that.actionData.model.fileName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.fileId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({ message: "Xóa bản tin " + that.actionData.model.fileName + " thành công" });
        that.loadDataMainTable();
      }
    });
    return {
      isSelectedAllDevices: false,
      loading: {
        value: false,
      },
      previewModel: {
        isShowModal: false,
        title: '',
        url: ''
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDate(30),
        end: new Date()
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      typeFileSelect: {
        options: {
          filter: true,
          label: "Loại tệp tin",
          selectAllText: "Tất cả loại tệp tin",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "type",
          model: '',
          items: [
            { key: '0', value: 'Biên tập' },
            { key: '1', value: 'Chuyển đổi văn bản' },
            { key: '2', value: 'Ghi âm tệp tin' },
            { key: '3', value: 'Ghép tệp tin' },
          ],
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            // { key: "index", label: "STT", sorter: false, filter: false },
            { key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%" },
            { key: "title", label: "Tiêu đề" },
            { key: "duration", label: "Thời lượng / Kích thước" },
            { key: "description", label: "Mô tả", sorter: false, filter: false },
            { key: "fileTypeName", label: "Lĩnh vực" },
            { key: "url", label: "Nội dung bản tin", sorter: false, filter: false },
            { key: "type", label: "Loại / Mức độ tệp tin", sorter: true, filter: false, _style: 'width:17%' },
            { key: "status", label: "Trạng thái" },
            { key: "locationName", label: "Nguồn tin" },
            { key: "action", label: "Thao tác", sorter: false, filter: false },
          ],
          slots: [
            "index", "createDate", "action", "duration", "url", "type", "description", "status", "locationName", "fileTypeName"
          ],
          lazyLoad: this.$hasAuthor('ROLE_WARD') || this.$hasAuthor('ROLE_VILLAGE') ? true : false,
          pageSize: 20,
          sorter: true,
          columnFilter: false,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        dataSource: {
          url: "/file-management/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    viewFile(title, url) {
      this.previewModel.url = url;
      this.previewModel.isShowModal = true;
      this.previewModel.title = title;
    },
    async downloadFile(item) {
      var url;
      if (item.type == 2) {
        if (item.url && item.pathFolderFile) {
          var itemsFile = item.pathFolderFile.split("/");
          var nameFile = itemsFile[itemsFile.length - 1];
          var urlFile = item.url.substring(0, item.url.lastIndexOf("/"));
          url = urlFile + "/" + nameFile
        }
      } else {
        url = item.url;
      }
      this.loading.value = true;
      if (item.keyStorage != null && item.keyStorage != '') {
        url = process.env.API_ENDPOINT + "/file-management/download/" + item.id;
      }
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      if (item.keyStorage != null && item.keyStorage != '') {
        a.download = item.keyStorage.substring(item.keyStorage.lastIndexOf("/") + 1, item.keyStorage.length);
      } else {
        a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      }
      a.click();
    },
    setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
      let actionData = this.actionData.model;
      actionData.fileId = fileId || null;
      actionData.fileName = fileName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(30),
          end: new Date()
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        // this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>

